import { updateContactDetailsMapping } from "../mapping/updateContactDetailsMapping";

export async function validateContactDetails(contactDetailsObject) {
	const mappedContactDetails =
		await updateContactDetailsMapping(contactDetailsObject);

	const { basicDetails } = { ...mappedContactDetails };

	const validations = [
		() => !!basicDetails?.email,
		() => !!basicDetails?.telephone?.mobile,
		() => !!basicDetails?.policyDocumentRequestType,
		() =>
			(!!basicDetails?.postalAddress?.fullAddress &&
				!!basicDetails?.postalAddress?.guid) ||
			!!basicDetails?.postalAddress?.postcode,
		() =>
			basicDetails.residentialAddressSameAs === false
				? !!basicDetails?.residentialAddress?.fullAddress ||
					!!basicDetails?.residentialAddress?.postcode
				: true,
	];

	let isValid = validations.every((validate) => validate());
	return isValid;
}
